import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"

import LazyRoutePage from "../../../-LazyRoutePage"

const CourierLabelPrintPage = lazy(
  () => import("../../../../components/WMS/Labels/CourierLabelPrintPage"),
)

export const Route = createFileRoute("/_layout/WMS/products/courier-labels")({
  component: CourierLabelPrintRoute,
})

function CourierLabelPrintRoute() {
  return (
    <LazyRoutePage>
      <CourierLabelPrintPage />
    </LazyRoutePage>
  )
}
